import { render } from "./DemandaVirtual.vue?vue&type=template&id=2e39da3d&scoped=true&ts=true"
import script from "./DemandaVirtual.vue?vue&type=script&lang=ts"
export * from "./DemandaVirtual.vue?vue&type=script&lang=ts"

import "./DemandaVirtual.vue?vue&type=style&index=0&id=2e39da3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e39da3d"]])

export default __exports__